<mat-form-field class="w-100" (click)="getGroupNameList()">
  <mat-label>{{ placeholder }}</mat-label>
  <input
    matInput
    [formControl]="groupNameFilter"
    [matAutocomplete]="groupNameList"
    (keyup)="validateContent()"
  />
  <button *ngIf="groupNameFilter.value && formIsEnabled" type="button" mat-icon-button matSuffix>
    <mat-icon class="button-clear-filter"
      (click)="cleanGroupName()"
      matTooltip="Borrar"
    >highlight_off</mat-icon>
  </button>
  <mat-autocomplete
    (optionSelected)="changeSelectGroupName()"
    #groupNameList="matAutocomplete"
    [displayWith]="displayFnGroupName"
  >
    <mat-option
      *ngFor="
        let entityGroup of groupNameAutocompleteList | async"
      [value]="entityGroup"
    >
      <span> {{ entityGroup.groupName }} </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
